module.exports = __webpack_public_path__ + "static/img/best_director_lg.c0afc23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best_director_lg.jpg
// module id = 71
// module chunks = 0